export default class Comment {
  constructor() {
    this.text = ''
  }
}
